import type {} from "@lit/react";
import { FormItem as FormItemElement, } from "@vaadin/form-layout/vaadin-form-item.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { FormItemElement, };
export type FormItemEventMap = Readonly<{}>;
const events = {} as FormItemEventMap;
export type FormItemProps = WebComponentProps<FormItemElement, FormItemEventMap>;
export const FormItem = createComponent({
    elementClass: FormItemElement, events, react: React, tagName: "vaadin-form-item"
});
